import * as React from 'react';
import MainContext from 'components/layout/MainContext';

export default function useIsSessionOpen (): boolean {
    const { session } = React.useContext(MainContext);
    return session !== null && session.token !== null;
}
